import { render, staticRenderFns } from "./DemoKeyboard.vue?vue&type=template&id=5a35d954"
import script from "./DemoKeyboard.vue?vue&type=script&lang=js"
export * from "./DemoKeyboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports